import Col from "../element/col";
import Row from "../element/row";
import Container from "../element/container";
import Lottie from "lottie-react";
import { NotFound } from "../../assets/lotties";

export default function CommonNotFound({ className, title, message }) {
  return (
    <Container className={`common-not-found ${className ?? ""}`}>
      <Row className="lottie-frame">
        <Lottie animationData={NotFound} />
      </Row>
      <Col className="v-flex gap-3 text-center">
        <h4>{title}</h4>
        <p>{message}</p>
      </Col>
    </Container>
  );
}
